export var BusinessSize;
(function (BusinessSize) {
    BusinessSize[BusinessSize["LARGE"] = 16000000] = "LARGE";
    BusinessSize[BusinessSize["MEDIUM"] = 8000000] = "MEDIUM";
    BusinessSize[BusinessSize["SMALL"] = 0] = "SMALL";
})(BusinessSize || (BusinessSize = {}));
